// Parámetros de prueba de la dirección, **solo en local**.
//
// `npm run dev` solo sirve `/`, así que se entra por la portada y se navega
// dentro de la aplicación, y el router suelta la query en el primer cambio de
// página. Por eso se leen una vez al arrancar (`main.js`) y se guardan para la
// sesión de la pestaña: siguen valiendo al pasar a Radio y al recargar.
//
//   ?vista-previa=<id>,<id>   conciertos sin aprobar en la franja
//   ?encuadre=0               apaga el encuadre automático, para comparar
//   ?probar-foto=<slug>       la foto de ese artista en Radio · En directo
//   ?visor=1                  el visor de Sonorama aunque suene otro programa
//   ?visor=crepusculo         el visor como en Crepúsculo: solo lo suave
//   ?visor=no                 como un programa sin visor: el selector, deshabilitado
//   ?visor-panel=1            el panel de prueba del visor (loops, bloques, ritmo)
//
// Con el valor vacío se borra (`?probar-foto=`). En producción no existen.

const NOMBRES = ["vista-previa", "encuadre", "probar-foto", "visor", "visor-panel"];
const PREFIJO = "astra-dev:";

const enLocal = () => process.env.NODE_ENV === "development" && typeof window !== "undefined";

export function recordarParametrosDev() {
  if (!enLocal()) return;
  const query = new URLSearchParams(window.location.search);
  for (const nombre of NOMBRES) {
    if (!query.has(nombre)) continue;
    try {
      const valor = query.get(nombre);
      if (valor) sessionStorage.setItem(PREFIJO + nombre, valor);
      else sessionStorage.removeItem(PREFIJO + nombre);
    } catch (e) {
      // Sin almacenamiento, el parámetro vale solo mientras siga en la dirección.
    }
  }
}

export function parametroDev(nombre) {
  if (!enLocal()) return null;
  const enDireccion = new URLSearchParams(window.location.search).get(nombre);
  if (enDireccion) return enDireccion;
  try {
    return sessionStorage.getItem(PREFIJO + nombre);
  } catch (e) {
    return null;
  }
}
